<script lang="ts">
    import src from './svg/left_panel_close_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let hover: string = 'Remove';
</script>

<TemplateIcon {src} {scale} alt={hover} on:click />
